import { useLocation } from 'react-router-dom';
import TenantListView from '../components/tenants/TenantListView';
import TenantFormView from '../components/tenants/TenantFormView';

export interface TenantsPageProps {
	createPermission?: string;
}

export default function TenantsPage({
	createPermission,
}: TenantsPageProps = {}) {
	const { pathname } = useLocation();

	// /iam/tenants exactly → list view
	// /iam/tenants/create, /iam/tenants/:id → form view
	if (pathname !== '/iam/tenants') {
		return <TenantFormView />;
	}

	return <TenantListView createPermission={createPermission} />;
}
